import './styles/SkeletonNotification.css';

export default function SkeletonNotification({ numberOfRows = 3 }) {

  const elements = Array.from({ length: numberOfRows }, (_, index) => (
    <div className="skeleton-notification__container" key={index}>
      <div className="skeleton-notification__user-image"/>
      <div className="skeleton-notification__notifications-container">
        <div className="skeleton-notification__line name"/>
        <div className="skeleton-notification__line"/>
        <div className="skeleton-notification__line"/>
        <div className="skeleton-notification__line short"/>
      </div>
    </div>
  ));
  return (
    <>
      {elements}
    </>
  );
}
